module.exports = __webpack_public_path__ + "static/media/template.e9844c4f.svg";